var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1447_8477)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.7093 16.3552L7.66711 16.3944C7.39801 16.6951 7.07065 16.938 6.70486 17.1085C6.33908 17.2789 5.9425 17.3733 5.53915 17.386C3.95976 17.386 2.81137 16.1984 2.81137 14.5618C2.81137 12.9251 3.95976 11.7406 5.53915 11.7406C5.9425 11.7532 6.33908 11.8476 6.70486 12.0181C7.07065 12.1885 7.39801 12.4315 7.66711 12.7322L7.7093 12.7744L8.72507 11.5416L8.69793 11.5115C8.32953 11.041 7.85736 10.6621 7.31829 10.4044C6.77922 10.1466 6.18785 10.0169 5.59038 10.0255C4.4059 9.99966 3.25526 10.4216 2.3683 11.2071C1.49143 12.1042 1.00049 13.3088 1.00049 14.5633C1.00049 15.8177 1.49143 17.0224 2.3683 17.9195C3.25448 18.7063 4.40566 19.1284 5.59038 19.101C6.18753 19.1095 6.77859 18.9801 7.31757 18.7229C7.85655 18.4657 8.32891 18.0876 8.69793 17.6181L8.72507 17.5849L7.7093 16.3552Z",
    fill: "#004785"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5493 10.1582H9.75293V18.9263H11.5493V10.1582Z",
    fill: "#004785"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5844 17.0154C18.1914 17.2815 17.7324 17.4338 17.2582 17.4554C16.6765 17.4554 16.4173 17.154 16.4173 16.4668V11.816H18.2469V10.1643H16.4173V7.43652L14.654 8.37694V10.1643H13.147V11.816H14.654V16.7652C14.654 18.1125 15.4528 19.0318 16.6464 19.0559C17.206 19.0851 17.7615 18.9454 18.2408 18.6551H18.2589L18.705 16.9581L18.5844 17.0154Z",
    fill: "#004785"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8667 10.1582H20.0703V18.9263H21.8667V10.1582Z",
    fill: "#004785"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9251 8.61838C22.121 7.47229 21.0528 6.53671 19.8107 5.89082C18.5686 5.24492 17.1892 4.90771 15.7892 4.90771C14.3892 4.90771 13.0097 5.24492 11.7676 5.89082C10.5255 6.53671 9.45728 7.47229 8.65324 8.61838L8.56885 8.73592H10.6335L10.6576 8.71182C11.3163 8.01139 12.1114 7.4532 12.9939 7.07166C13.8764 6.69012 14.8277 6.49329 15.7892 6.49329C16.7506 6.49329 17.7019 6.69012 18.5844 7.07166C19.467 7.4532 20.262 8.01139 20.9207 8.71182L20.9448 8.73592H23.0095L22.9251 8.61838Z",
    fill: "#ED1C2E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1447_8477"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 14.1844,
    fill: "white",
    transform: "translate(1 4.90771)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24);
export default __webpack_public_path__ + "static/media/씨티-24.65a5ab7225de4befa65779acf805233e.svg";
export { ForwardRef as ReactComponent };